Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMapData = updateMapData;
exports.setMapData = setMapData;
exports.setMapResults = setMapResults;

var _constants = require('../constants');

var _query = require('./query');

var _value = require('./value');

var _transform = require('../utils/transform');

var _constants2 = require('../utils/constants');

function updateMapData(componentId, query, persistMapQuery) {
  return {
    type: _constants.SET_MAP_DATA,
    componentId: componentId,
    query: query,
    persistMapQuery: persistMapQuery
  };
}

function setMapData(componentId, query, persistMapQuery, forceExecute) {
  var meta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var queryId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  return function (dispatch) {
    dispatch(updateMapData(componentId, query, persistMapQuery));
    dispatch((0, _value.setInternalValue)((0, _transform.getInternalComponentID)(componentId), undefined, undefined, undefined, meta));

    if (forceExecute) {
      var executeWatchList = false;
      var mustExecuteMapQuery = true;
      dispatch((0, _query.executeQuery)(componentId, executeWatchList, mustExecuteMapQuery, _constants2.componentTypes.reactiveMap, {}, queryId));
    }
  };
}

function setMapResults(componentId, _ref) {
  var center = _ref.center,
      zoom = _ref.zoom,
      markers = _ref.markers;
  return {
    type: _constants.SET_MAP_RESULTS,
    componentId: componentId,
    payload: {
      center: center,
      zoom: zoom,
      markers: markers
    }
  };
}